export const facebook = "https://www.facebook.com/santasanswers";

export const instagram = "https://www.instagram.com/santasanswers";

export const twitter = "https://www.twitter.com/santasanswers";

export const email = "mailto:info@santasanswers.com";
